export default function promiseMiddleware(_ref) {
  // eslint-disable-next-line prefer-destructuring
  const dispatch = _ref.dispatch;

  return next => action => {
    if (!action.payload || !action.payload.then) {
      return next(action);
    }

    dispatch(
      Object.assign({}, action, {
        status: "pending",
        promise: action.payload,
        payload: null
      })
    );
    return action.payload.then(
      result => {
        dispatch(Object.assign({}, action, { status: "success", payload: result }));
        return result;
      },
      error => {
        dispatch(Object.assign({}, action, { status: "error", payload: error }));
        // eslint-disable-next-line no-console
        console.error(error.stack);
        throw error;
      },
      () => {
        // onCancel
        dispatch(Object.assign({}, action, { status: "cancelled", payload: null }));
      }
    );
  };
}
